import userSaga from "@redux/saga/user.saga";
import { Table, Row, Col, Input, Pagination, Button, notification, Checkbox, Empty, Radio, RadioChangeEvent } from "antd";
import React, { useEffect, useState } from "react";
import { getMacDeviceApps,getMacDeviceManagedApps } from "../../axios/api.device";

import { useTranslation } from "react-i18next";

const { Column } = Table;

interface propsModel {
  id: string,
  platform: string,
  deviceType: string
}

export const MacDeviceDetailApps = (props: propsModel) => {
  // const data = new Array(10).fill({ a: 1 });
  const { id, platform, deviceType } = props;
  const [data, setData] = useState<any[]>();
  const [data2, setData2] = useState<any[]>();
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [pageIndex2, setPageIndex2] = useState<number>(1);
  const [pageSize2, setPageSize2] = useState<number>(10);
  const [totalCount2, setTotalCount2] = useState<number>(0);
  const [search, setSearch] = useState<string>("");
  const [appType, setAppType] = useState<string>('installedApp');
  const { t } = useTranslation();

  useEffect(() => {
    if (id) {
      getData(1,10);
    }
  }, []);

  const getData = (index: number , size: number) => {
    if(appType === 'installedApp'){
      getMacDeviceApps(
        id, 
        {
          pageIndex: index, 
          pageSize: size, 
          search: search
        }
      ).then(
        (res) => {
          setPageIndex(res.pageIndex);
          setPageSize(res.pageSize);
          setData(res.dataList);
          setTotalCount(res.totalCount);
        },
        (e) => { notification.error({message: e.message}) }
      );
    }
    else{
      getMacDeviceManagedApps(
        id, 
        {
          pageIndex: index, 
          pageSize: size, 
          search: search
        }
      ).then(
        (res) => {
          setPageIndex2(res.pageIndex);
          setPageSize2(res.pageSize);
          setData2(res.dataList);
          setTotalCount2(res.totalCount);
        },
        (e) => { notification.error({message: e.message}) }
      );
    }
  };

  const handleModeChange = (e: RadioChangeEvent) => {
    setAppType(e.target.value);
    getData(1,10);
  };
  return (
    <>
      <Row className="mb-2">
        <Col>
          <Radio.Group onChange={handleModeChange} value={appType} style={{ marginBottom: 8 }}>
            <Radio.Button value="installedApp">已安装应用</Radio.Button>
            <Radio.Button value="vppApp">VPP应用</Radio.Button>
          </Radio.Group>
        </Col>
        <Col><span style={{lineHeight: "32px", marginRight: "5px",marginLeft:"100px"}}>{t("应用名称")}:</span></Col>
        <Col>
          <Input
            placeholder={t("输入名称搜索")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          ></Input>
        </Col>
        <Col>
          <Button type="primary" onClick={() =>{ getData(1,10);}}>{t("搜索")}</Button>
        </Col>
      </Row>
      {appType == 'installedApp' && <>
        <Table 
          dataSource={data} 
          rowKey="path" 
          pagination={false} 
          size="small"
          locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
        >
          <Column title={t("名称")} key="appName" dataIndex="appName"></Column>
          <Column title={t("版本")} key="appVersion" dataIndex="appVersion"></Column>
          <Column title={t("路径")} key="path" dataIndex="path"></Column>
          
        </Table>
        <Pagination
          style={{ textAlign: "right", marginTop: "20px" }}
          pageSize={pageSize}
          current={pageIndex}
          total={totalCount}
          showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
          onChange={(page, pageSize) => {
            getData(page, pageSize);
          }}
          onShowSizeChange={(current, size) => getData(current, size)}
        ></Pagination>
      </>}

      {appType == 'vppApp' && <>
        <Table 
          dataSource={data2} 
          rowKey="path" 
          pagination={false} 
          size="small"
          locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
        >
          <Column title={t("名称")} key="appName" dataIndex="appName"></Column>
          <Column title={t("大小")} key="appSize" dataIndex="appSize"></Column>
          <Column title={t("版本")} key="appVersion" dataIndex="appVersion"></Column>
          <Column title={t("包名")} key="packageName" dataIndex="packageName"></Column>
          <Column title={t("受管理App")} key="isManaged" dataIndex="isManaged" render={(r)=>r?t("是"):t("否")}></Column>
        </Table>
        <Pagination
          style={{ textAlign: "right", marginTop: "20px" }}
          pageSize={pageSize2}
          current={pageIndex2}
          total={totalCount2}
          showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
          onChange={(page, pageSize) => {
            getData(page, pageSize);
          }}
          onShowSizeChange={(current, size) => getData(current, size)}
        ></Pagination>
      </>}
    </>
  );
};
